var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgA3(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00909 15C2.26607 7.94172 7.94172 2.26607 15 2.00909V15H2.00909Z",
    stroke: "#C2C2C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 29.9909C7.94172 29.7339 2.26607 24.0583 2.00909 17H15V29.9909Z",
    stroke: "#C2C2C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.00909C24.0583 2.26607 29.7339 7.94172 29.9909 15H17V2.00909Z",
    stroke: "#C2C2C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 18.0833C16.9281 18.0833 17.2934 17.8143 17.436 17.436C17.8143 17.2934 18.0833 16.9281 18.0833 16.5H21.9167C21.9167 17.0523 22.3644 17.5 22.9167 17.5H24.0833C24.6356 17.5 25.0833 17.0523 25.0833 16.5H28.9167C28.9167 16.9509 29.2151 17.3321 29.6251 17.4568C29.7866 17.7376 30.0809 17.9337 30.4251 17.9568C30.3353 18.8256 30.166 19.6708 29.9247 20.4851C29.4167 20.314 28.8607 20.575 28.6703 21.0806C28.5701 21.3467 28.4614 21.6087 28.3445 21.8662C28.1213 22.3582 28.3295 22.9361 28.8095 23.1747C28.397 23.9339 27.9163 24.6506 27.3756 25.3167C26.9718 24.964 26.3579 24.9922 25.9884 25.3866C25.7944 25.5936 25.5936 25.7944 25.3866 25.9884C24.9922 26.3579 24.964 26.9718 25.3167 27.3756C24.6506 27.9163 23.9339 28.397 23.1747 28.8095C22.9361 28.3295 22.3582 28.1213 21.8662 28.3445C21.6087 28.4614 21.3467 28.5701 21.0806 28.6703C20.575 28.8607 20.314 29.4167 20.4851 29.9247C19.6708 30.166 18.8256 30.3353 17.9568 30.4251C17.9337 30.0809 17.7376 29.7866 17.4568 29.6252C17.3321 29.2151 16.9509 28.9167 16.5 28.9167V25.0833C17.0523 25.0833 17.5 24.6356 17.5 24.0833V22.9167C17.5 22.3644 17.0523 21.9167 16.5 21.9167V18.0833Z",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "1 5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA3);
export default __webpack_public_path__ + "static/media/a3.e5d570adf4a630f20e30d9a8bcb4b001.svg";
export { ForwardRef as ReactComponent };